"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_BUTTON_TYPE = void 0;
var PAGE_BUTTON_TYPE;
(function (PAGE_BUTTON_TYPE) {
    PAGE_BUTTON_TYPE["PREVIOUS"] = "previous";
    PAGE_BUTTON_TYPE["NEXT"] = "next";
})(PAGE_BUTTON_TYPE = exports.PAGE_BUTTON_TYPE || (exports.PAGE_BUTTON_TYPE = {}));
;
var PageButton = /** @class */ (function (_super) {
    __extends(PageButton, _super);
    function PageButton(textures, type, action) {
        var _this = _super.call(this) || this;
        _this._textures = textures;
        _this._type = type;
        _this._action = action;
        _this.addChild(_this.icon);
        _this.interactive = true;
        _this.on("pointerdown", function () {
            action(this);
        });
        return _this;
    }
    Object.defineProperty(PageButton.prototype, "icon", {
        get: function () {
            if (!this._icon) {
                this._icon = PIXI.Sprite.from(this._textures["page_" + this._type + ".png"]);
            }
            return this._icon;
        },
        enumerable: false,
        configurable: true
    });
    return PageButton;
}(PIXI.Container));
exports.default = PageButton;
